import { render, staticRenderFns } from "./ArticleInfoPage.vue?vue&type=template&id=f2d15134&scoped=true"
import script from "./ArticleInfoPage.vue?vue&type=script&lang=js"
export * from "./ArticleInfoPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleInfoPage.vue?vue&type=style&index=0&id=f2d15134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d15134",
  null
  
)

export default component.exports